import { Helmet } from "react-helmet-async";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { PageHeader } from "../components/PageHeader";
import { ClosingCTA } from "../components/marketing/ClosingCTA";
import { Download, FileText, ExternalLink } from "lucide-react";

const assets = [
  {
    title: "Logo pack",
    description: "SVG, PNG, and monochrome variants.",
    icon: Download,
    href: "https://drive.google.com/drive/folders/19unipPS2XrU9KthKblPGFxQn9NijJqs-?usp=sharing",
  },
  {
    title: "Brand guidelines",
    description: "Palette, typography, voice (PDF).",
    icon: FileText,
    href: "https://drive.google.com/file/d/1DN18WJBzrOZu-c2eDoOQYEajHRIWEcns/view?usp=sharing",
  },
];

export default function Press() {
  return (
    <main className="min-h-screen bg-aubergine" data-testid="press-page">
      <Helmet>
        <title>Press · T-REX Network</title>
        <meta name="description" content="Press & media. Brand assets and media inquiries for T-REX Network." />
        <meta property="og:title" content="Press · T-REX Network" />
        <meta property="og:description" content="Press &amp; media." />
      </Helmet>
      <Navbar />
      <PageHeader
        eyebrow="Press"
        headline="Press & media."
        highlightWord="media"
        subheadline="Brand assets and media contact for T-REX Network."
        primaryCta={{ label: "Media inquiries", href: "/contact?inquiry=media" }}
        compact
      />

      <section id="assets" className="surface-day py-20 lg:py-28">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="max-w-2xl mb-10">
            <p className="font-mono text-[11px] font-medium text-champagne uppercase tracking-[0.2em] mb-4">Assets</p>
            <h2 className="trex-h2 text-bone leading-[1.1]">Brand <em className="accent-italic">assets</em>.</h2>
          </div>
          <div className="grid gap-6 sm:grid-cols-2">
            {assets.map((a) => (
              <a
                key={a.title}
                href={a.href}
                target="_blank"
                rel="noopener noreferrer"
                className="group rounded-md border border-champ-light/10 bg-aubergine-tier p-8 hover:border-champagne/40 transition-colors"
                data-testid={`press-asset-${a.title.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <div className="flex items-start justify-between gap-4">
                  <a.icon className="h-5 w-5 text-champagne" />
                  <ExternalLink className="h-3.5 w-3.5 text-bone/35 group-hover:text-champagne transition-colors" />
                </div>
                <h3 className="mt-4 text-base font-medium text-bone group-hover:text-champ-light transition-colors">{a.title}</h3>
                <p className="mt-2 text-sm text-bone/70 leading-relaxed">{a.description}</p>
              </a>
            ))}
          </div>
        </div>
      </section>

      <ClosingCTA variant="media" tone="day" />
      <Footer />
    </main>
  );
}
